module.exports = function transformVideoData(
	entity,
	media_field_name = "field_media_video",
	media_rel = null
) {
	let video;
	if (!media_rel && media_field_name && entity) {
		media_rel =
			entity && entity.relationships && entity.relationships[media_field_name]
				? entity.relationships[media_field_name].data
				: null;
	}
	if (media_rel) {
		const title =
			media_rel.attributes && media_rel.attributes.name
				? media_rel.attributes.name
				: null;
		let thumbnail = {
			alt: title,
			title: "",
			width: 640,
			height: 340,
			url: null,
		};

		if (media_rel.type === "media--video_stream") {
			let cloudflare = media_rel.attributes.field_video_id;
			if (
				media_rel.relationships &&
				media_rel.relationships.field_media_image &&
				media_rel.relationships.field_media_image.data &&
				media_rel.relationships.field_media_image.data.attributes
			) {
				thumbnail.url = media_rel.relationships.field_media_image.data.attributes
					.image_style_uri
					? media_rel.relationships.field_media_image.data.attributes.image_style_uri
							.crop_thumbnail
					: `${process.env.GATSBY_BACKEND_URL}${media_rel.relationships.field_media_image.data.attributes.uri.url}`;
			}
			if (!thumbnail.url) {
				thumbnail.url = `https://customer-${process.env.GATSBY_CLOUDFLARE_CLIENT}.cloudflarestream.com/${cloudflare}/thumbnails/thumbnail.jpg`;
			}
			// if (!thumbnail.url) {
			// 	thumbnail.url = "/default.jpg";
			// }
			video = {
				title,
				cloudflare,
				thumbnail,
				poster: thumbnail.url,
			};
		} else {
			if (
				media_rel.relationships &&
				media_rel.relationships.thumbnail &&
				media_rel.relationships.thumbnail.data &&
				media_rel.relationships.thumbnail.data.attributes
			) {
				thumbnail = {
					...media_rel.relationships.thumbnail.data.meta,
					...media_rel.relationships.thumbnail.data.attributes.uri,
				};
				thumbnail.url =
					media_rel.relationships.thumbnail.data.attributes.image_style_uri &&
					media_rel.relationships.thumbnail.data.attributes.image_style_uri.crop_thumbnail
						? media_rel.relationships.thumbnail.data.attributes.image_style_uri
								.crop_thumbnail
						: `${process.env.GATSBY_BACKEND_URL}${media_rel.relationships.thumbnail.data.attributes.uri.url}`;
			}

			let url;
			if (media_rel.type === "media--remote_video") {
				if (media_rel.attributes && media_rel.attributes.field_media_oembed_video) {
					url = media_rel.attributes.field_media_oembed_video;
				}
			} else if (media_rel.type === "media--video") {
				url =
					media_rel.relationships &&
					media_rel.relationships.field_media_video_file &&
					media_rel.relationships.field_media_video_file.data
						? `${process.env.GATSBY_BACKEND_URL}${media_rel.relationships.field_media_video_file.data.attributes.uri.url}`
						: null;
			}

			if (url && thumbnail) {
				video = {
					title,
					url,
					thumbnail,
					poster: thumbnail.url,
				};
			}
		}
	}

	let data = {
		id: entity.id,
		type: entity.type,
	};
	if (video) data = { ...data, ...video };
	return data;
};
